import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=02a5affe&scoped=true&"
import script from "./AppLoader.vue?vue&type=script&lang=js&"
export * from "./AppLoader.vue?vue&type=script&lang=js&"
import style0 from "./AppLoader.vue?vue&type=style&index=0&id=02a5affe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a5affe",
  null
  
)

export default component.exports